import StyleConfig from "@/views/api/wap/style-config.js";
import { setBackGround, removeBackGround } from "@/utils/wapAuth";
const state = {
  style: {
    c_cyan_background: "#00aea9",
    c_white_background: "#ffffff",
    c_inherit_background: "#b7b7b7",
    c_white_text_important: "#ffffff",
    c_white_text_important_hover: "#ffffff",
    c_white_text_important_focus: "#ffffff",
    c_red_text: "#de003f",
    c_white_text: "#ffffff",
    c_text_main: "#00aea9",
    c_error_text: "#de003f",
    c_divider_text: "#88d9d7",
    c_primary_text: "#00aea9",
    c_initial_text: "#272626",
    c_inherit_text: "#b7b7b7",
    c_link_text: "#177dc5",
    c_link_text_hover: "#177dc5",
    c_link_text_focus: "#177dc5",
    c_button_main: "#00aea9",
    c_border: "#daa520",
    c_button_search: "#daa520",
    c_button_text: "#de003f",
    c_header: "#00aea9",
    c_banner: "#00aea9",
    c_footer: "#00aea9",
    c_menu_header: "#ffffff",
    colorMain: "#00aea9",
    logo: "https://cdn.vcallid.com/e95dc8cb-eed1-42b9-9127-3d2919fc42f6.png",
    logo_footer:
      "https://cdn.vcallid.com/e95dc8cb-eed1-42b9-9127-3d2919fc42f6.png"
  }
};

const mutations = {
  SET_STYLE: (state, style) => {
    state.style = style;
  }
};

const actions = {
  setStyle({ commit }, style) {
    return new Promise((resolve, reject) => {
      StyleConfig.getStyleConfig({ merchant: style.merchant })
        .then(res => {
          if (res.error_code === 0) {
            if (res.data.config) {
              const data = JSON.parse(res.data.config);
              const newObject = {};
              for (const key in data) {
                newObject[key] = data[key].value;
              }
              console.log("newObject______________________", newObject);
              setBackGround(newObject);
            } else {
              removeBackGround();
            }
            resolve(res);
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};

export default {
  state,
  mutations,
  actions
};
